import { AddNewRecordCellRenderer } from './AddNewRecordCellInnerComponents'
import { DataGridCell } from './types'

export const AddNewRecordCell: DataGridCell = {
    provideRenderer: AddNewRecordCellRenderer,
}
